import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Engagementstatsdisplay from "./sections/Engagementstatsdisplay"
import InformasiKontak from "@/reusable_sections/Footer"
import Articlemetainfo from "./sections/Articlemetainfo"
import Livenewstickerbar from "./sections/Livenewstickerbar"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <SinglePostTemplateSection />
      <Articlemetainfo />
      <Engagementstatsdisplay />
      <Livenewstickerbar />
      <InformasiKontak />
    </div>
  )
}